import React, { useContext, useMemo } from 'react';

import RadioGroupRow from 'components/UI/Form/Row/RadioGroupRow/RadioGroupRow';
import { cartContext } from 'contexts/cartContext';
import { useTranslation } from 'react-i18next';
import { CartGiftsChoiceType } from 'types/Cart';

import styles from './PrivilegeGiftForm.module.scss';

export default function PrivilegeGiftForm({
  gifts,
}: {
  gifts: CartGiftsChoiceType[];
}): JSX.Element {
  const { t } = useTranslation();
  const { updateGiftChoice } = useContext(cartContext);
  const options = useMemo(() => {
    return gifts.map(gift => {
      return { id: gift.code_am, label: gift.message, value: gift.code_am };
    });
  }, [gifts]);

  function handleChange(e) {
    const giftChoice = { giftChoice: e.target.value };
    updateGiftChoice(giftChoice);
  }

  return (
    <>
      <p className={styles.title}>{t('LABEL_CHOOSE_BENEFITS')}</p>
      <RadioGroupRow
        classes={{ container: styles.container, option: styles.option }}
        name={'gift'}
        options={options}
        onChange={handleChange}
      />
    </>
  );
}
